<div class="d-flex flex-wrap gap-2 align-items-center">
  @if (this.loading) {
    <p-button
      [loading]="true"
      [disabled]="true"
      i18n-label="@@bot-image-generating"
      label="Wird generiert…"
    ></p-button>
  }

  @if (!this.loading) {
    @if (!this.hasImage) {
      <p-button
        severity="secondary"
        [outlined]="true"
        icon="ri-image-ai-line"
        (onClick)="genPopover.toggle($event)"
        i18n-label="@@bot-image-generate-ai-title"
        label="Mit KI generieren"
      ></p-button>
    }
    @if (!this.hasImage) {
      <p-button
        severity="secondary"
        [outlined]="true"
        icon="ri-file-image-line"
        (onClick)="op.toggle($event)"
        i18n-label="@@bot-image-from-document-title"
        label="Aus Dokument wählen"
      ></p-button>
    }
    @if (this.hasImage) {
      <p-button
        severity="danger"
        [outlined]="true"
        icon="ri-delete-bin-line"
        (onClick)="this.deleteImage()"
        i18n-label="@@bot-image-delete-title"
        label="Bild entfernen"
      ></p-button>
    }
  }
</div>

<p-popover #genPopover>
  <div
    class="d-flex flex-column gap-2"
    style="min-width: 280px;"
    >
    <span
      class="fw-semibold"
      i18n="@@bot-image-generate-ai-title"
    >Mit KI generieren</span>

    <textarea
      pInputTextarea
      class="w-100"
      rows="3"
      [(ngModel)]="this.customPrompt"
      i18n-placeholder="@@bot-image-generate-prompt-placeholder"
      placeholder="Eigene Beschreibung (optional) – leer lassen für automatische Beschreibung anhand der Bot-Anweisung"
    ></textarea>

    <p-button
      (onClick)="this.reloadImage(); genPopover.hide()"
      i18n-label="@@bot-image-generate-submit"
      label="Bild generieren"
    ></p-button>
  </div>
</p-popover>

<p-popover #op>
  <div style="min-width: 220px; max-height: 260px; overflow-y: auto;">
    @if (this.rss._allImageSkills().length === 0) {
      <span
        class="text-muted small"
        i18n="@@bot-image-no-documents"
      >Noch keine Bild-Dokumente im Projekt vorhanden.</span>
    }
    @for (skillId of this.rss._allImageSkills(); track skillId) {
      <div
        class="dropdown-item cursor-pointer"
        (click)="this.setImageFromSkill(skillId); op.hide()"
        >
        {{skillId}}
      </div>
    }
  </div>
</p-popover>